import axios from 'axios';
const API_URL = process.env.REACT_APP_API_LINK;
const API_URL_CLIENT = process.env.REACT_APP_API_LINK;

const axiosInstance = axios.create({
    'headers': {
        'Authorization': `Stickball ${localStorage.getItem('token')}`,
        'x-api-key': process.env.REACT_APP_X_API_KEY
    }
})

export const addJournal = async (data) => {

    const res = await axiosInstance.post(`${API_URL}/journal`, data, {
        'headers': {
            'Authorization': `Stickball ${localStorage.getItem('token')}`
        }
    });
    return res.data;
}
export const shareJournal = async (data) => {

    const res = await axiosInstance.post(`${API_URL}/journal/share`, data, {
        'headers': {
            'Authorization': `Stickball ${localStorage.getItem('token')}`
        }
    });
    return res.data;
}

export const getJournals = async () => {
    const res = await axiosInstance.get(`${API_URL}/journal/client`, {
        'headers': {
            'Authorization': `Stickball ${localStorage.getItem('token')}`
        }
    })
    return (res.data)
}
// export const getQuestions = async () => {
//     const res = await axiosInstance.get(`${API_URL}/journal?type=question`)
//     return (res.data)
// }
export const updateJournal = async (data) => {
    let temp = {}
    if (data.type === 'question') {
        temp = {
            question: data.question,
            title: data.title,
            // isAnswer: isAnwered,
            teacher: data.teacher,
            answer: data.answer,
        }
    } else {
        temp = {
            title: data.title,
            content: data.content,
            attachment: data.attachment,
        }
    }

    const res = await axiosInstance.put(`${API_URL}/journal/${data.id}`, temp, {
        'headers': {
            'Authorization': `Stickball ${localStorage.getItem('token')}`
        }
    })
    return (res.data)
}

export const deleteJournal = async (data) => {
    const res = await axiosInstance.delete(`${API_URL}/journal/${data.id}`, {
        'headers': {
            'Authorization': `Stickball ${localStorage.getItem('token')}`
        }
    })
    return (res.data)
}

export const getAdminList = async () => {
    const res = await axiosInstance.get(`${API_URL}/admin`, {
        'headers': {
            'Authorization': `Stickball ${localStorage.getItem('token')}`
        }
    })
    return (res.data)
}
export const getAdmindzByOrg = async () => {
    const res = await axiosInstance.get(`${API_URL}/admin`)
    return (res.data)
}

export const getTeachersByOrg = async (orgId) => {
    const res = await axiosInstance.get(`${API_URL}/organization/${orgId}/admins?roleId=2`)
    return (res.data)
}

export const getParentsByOrg = async (orgId) => {
    const res = await axiosInstance.get(`${API_URL}/organization/${orgId}/admins?roleId=4`)
    return (res.data)
}

export const getMentorByOrg = async (orgId) => {
    const res = await axiosInstance.get(`${API_URL}/organization/${orgId}/admins?roleId=3`)
    return (res.data)
}

export const getAllAdminsByOrgAndRole = async (id, roleId) => {
    const res = await axiosInstance.get(`${API_URL}/organization/${id}/admins?roleId=${roleId}`);
    return res.data;
  };

export const getUsers = async () => {
    const res = await axiosInstance.get(`${API_URL}/user`,
        {
            headers: {
                'Authorization': `Stickball ${localStorage.getItem('token')}`
            }
        }
    );
    return res.data;
}

export const getAIJournalSuggestion = async (prompt) => {
    const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
            model: "gpt-4o",
            messages: [
                {
                    role: "system",
                    content: "You are a helpful assistant that creates journal entries. Basically you have to create notes for users as a journal. Always respond with a JSON object in the format: {\"name\": \"title of the journal\", \"description\": \"detailed content of the journal\"}. But always remember in that json name and description should be simple text, no styling should be added. use line breaks or numbring only."
                },
                {
                    role: "user",
                    content: prompt
                }
            ],
            response_format: { type: "json_object" }
        },
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
            },
        }
    );

    const content = response.data.choices[0].message.content;
    // Parse the content to ensure it's valid JSON
    return JSON.parse(content);
};